/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ journey: NonNullable<unknown> }} Map_Steps_LabelInputs */

const en_map_steps_label = /** @type {(inputs: Map_Steps_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The steps of ${i?.journey}`)
};

/**
* | output |
* | --- |
* | "The steps of {journey}" |
*
* @param {Map_Steps_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_steps_label = /** @type {((inputs: Map_Steps_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Steps_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_steps_label(inputs)
});